export default "__VITE_ASSET__2BzcD56A__"